import { Link } from 'react-router-dom';
import { BUILDING_NAMES, TEAM_PLANET_ECONOMY_MULTIPLIER, TEAM_PLANET_REQUIRED_BUILDING_LEVEL } from '@kaeliux/shared';
import { Panel } from '../ui/Panel';
import { Icon } from '../ui/Icon';
import { linkButtonClasses } from '../ui/buttonStyles';
import { cn } from '../../utils/cn';

interface TeamPlanetEmptyStateProps {
    reason: 'no-alliance' | 'no-team-planet';
    isLeader?: boolean;
    /** Off inside the Alliance page itself, where a link back to it would be circular. */
    showAllianceLink?: boolean;
}

/** What `/team-planet` and the Alliance page's Team Planet tab show before there is a Team planet to open. */
export default function TeamPlanetEmptyState({ reason, isLeader = false, showAllianceLink = true }: TeamPlanetEmptyStateProps) {
    const noAlliance = reason === 'no-alliance';
    return (
        <Panel variant="solid" padding="md" className="flex flex-col gap-3 max-w-2xl" data-testid="team-planet-empty-state">
            <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-hairline-strong bg-space-950 text-content-secondary">
                    <Icon name="alliance" size={20} aria-hidden="true" />
                </span>
                <h2 className="text-title text-content-primary">{noAlliance ? 'No alliance yet' : 'No Team planet yet'}</h2>
            </div>
            <p className="text-body text-content-muted">
                {noAlliance
                    ? 'A Team planet belongs to an alliance. Join or found one to share a planet with its members.'
                    : `A Team planet is shared by the whole alliance, with ${TEAM_PLANET_ECONOMY_MULTIPLIER}× the income and storage of a normal planet. Members fund it with Transport flights.`}
            </p>
            {!noAlliance && (
                <p className="text-body text-content-muted">
                    {isLeader
                        ? `Convert one of your colonies from its own planet page. It must have no flights to or from it, and one of your planets needs the ${BUILDING_NAMES.government} at Level ${TEAM_PLANET_REQUIRED_BUILDING_LEVEL}.`
                        : 'Only the alliance leader may convert a planet into it.'}
                </p>
            )}
            {showAllianceLink && (
                <Link to="/alliance" className={cn(linkButtonClasses('secondary', 'sm'), 'self-start')}>
                    Open Alliance
                </Link>
            )}
        </Panel>
    );
}
